import {
  AnyTeamEntityVersion,
  StorageFolder,
  SubscriptionEntity,
  Team,
  TeamTrialInfo,
} from '@uploadcam/common';
import { GetTeamByIdInteractor } from './get-team-by-id.interactor';
import { CollectionReference, doc, setDoc } from 'firebase/firestore';

interface UpdateTeamData {
  name?: string;
  folder?: StorageFolder;
  subscription?: SubscriptionEntity;
  trial?: TeamTrialInfo;
}

export class UpdateTeamInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyTeamEntityVersion>,
    private readonly getTeamById: GetTeamByIdInteractor,
  ) {}

  public async execute(teamId: string, data: UpdateTeamData): Promise<Team> {
    await setDoc(doc(this.collection, teamId), data, { merge: true });

    return this.getTeamById.execute(teamId);
  }
}
